import React from 'react';
import './Loader.scss';

const Loader = () => (
    <div className="loader-container">
        <div className="spinner" />
        <p>Loading, please wait...</p>
    </div>
);

export default Loader;
